import { render, staticRenderFns } from "./entities.vue?vue&type=template&id=1e55659e&"
import script from "./entities.component.ts?vue&type=script&lang=ts&"
export * from "./entities.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports